module.exports = __webpack_public_path__ + "static/img/uav.644f310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/uav.jpg
// module id = yukb
// module chunks = 2